import { NumberInput, Select, Stack } from '@mantine/core';
import { UseFormReturnType } from '@mantine/form';
import P4Medium from 'components/typography/P4Medium';
import { useMemo } from 'react';

export interface IImageFormat {
  align?: 'left' | 'center' | 'right';
  maxWidth?: number;
  maxHeight?: number;
  imageSize?: 'small' | 'medium' | 'large';
}

/**
 * Configurator for placeholders which are images.
 */
export default function ImageConfigurator({ form }: { form: UseFormReturnType<IImageFormat> }) {
  const alignOptions = useMemo(
    () => [
      { value: 'left', label: 'Vľavo' },
      { value: 'center', label: 'Na stred' },
      { value: 'right', label: 'Vpravo' },
    ],
    []
  );

  const imageSizeOptions = useMemo(
    () => [
      { value: 'small', label: 'Malá (90 kB)' },
      { value: 'medium', label: 'Stredná (180 kB)' },
      { value: 'large', label: 'Veľká (360 kB)' },
    ],
    []
  );

  return (
    <Stack spacing={12}>
      <Select
        label="Zarovnanie"
        size="sm"
        data={alignOptions}
        defaultValue="center"
        required
        {...form.getInputProps('align')}
      />
      <NumberInput
        label="Maximálna šírka"
        size="sm"
        min={0}
        placeholder="Celá šírka bunky (automaticky)"
        rightSection={<P4Medium c="gray.5">mm</P4Medium>}
        {...form.getInputProps('maxWidth')}
      />
      <NumberInput
        label="Maximálna výška"
        size="sm"
        min={0}
        placeholder="Zachovať pomer strán (automaticky)"
        rightSection={<P4Medium c="gray.5">mm</P4Medium>}
        {...form.getInputProps('maxHeight')}
      />
      <Select
        label="Veľkosť obrázka"
        size="sm"
        data={imageSizeOptions}
        defaultValue="small"
        required
        {...form.getInputProps('imageSize')}
      />
    </Stack>
  );
}
